<uc-main-header
	heading="Careers, Degree Subjects and UK Cities"
	description="A-Z of university guides, guides for degrees, careers, cities and internships"
	backgroundStyle="bg-guides"
>
	<uc-guides-header-navigation />
</uc-main-header>

<!-- degree -->
@if ((degreeGuides$ | async)?.popular_guides; as degreeGuides) {
	<div class="container">
		<div class="divider">
			<uc-guides-carousel
				ngSkipHydration
				categoryGuide="University"
				categoryUrl="subject"
				guideTitle="Subject Degree Guides"
				[guides]="degreeGuides"
				next="swiper-button-next-subject"
				prev="swiper-button-prev-subject"
				pagination="carousel-index-subject"
			/>
			<uc-guides-carousel-footer
				categoryTitle="Subject Degree Guides"
				description="View our full list of subject Guides"
				categoryUrl="subject"
			/>
		</div>
	</div>
}

<!-- snigel google ads -->
<div class="container">
	<div class="divider">
		<!-- mobile add -->
		<div class="sm:hidden">
			<div id="adngin-incontent_1_mob-0" class="mx-auto incontent_1_mob-0"></div>
		</div>

		<!-- desktop add -->
		<div class="hidden sm:block">
			<div id="adngin-incontent_1_dskt-0" class="mx-auto incontent_1_dskt-0"></div>
		</div>
	</div>
</div>

<!-- city -->
<div class="bg-gray-50">
	@if ((cityGuides$ | async)?.popular_guides; as cityGuides) {
		<div class="container divider !border-b-0">
			<uc-guides-carousel
				ngSkipHydration
				categoryGuide="University"
				categoryUrl="city"
				guideTitle="Student City Guides"
				[guides]="cityGuides"
				next="swiper-button-next-city"
				prev="swiper-button-prev-city"
				pagination="carousel-index-city"
			/>
			<uc-guides-carousel-footer
				categoryTitle="University City Guides"
				description="View our full list of university city guides"
				categoryUrl="city"
			/>
		</div>
	}
</div>

<!-- career -->
@if ((careerGuides$ | async)?.popular_guides; as careerGuides) {
	<div class="container divider !border-b-0">
		<uc-guides-carousel
			ngSkipHydration
			categoryGuide="Career"
			categoryUrl="career"
			guideTitle="Student Career Guides"
			[guides]="careerGuides"
			next="swiper-button-next-career"
			prev="swiper-button-prev-career"
			pagination="carousel-index-career"
		/>
		<uc-guides-carousel-footer
			categoryTitle="Career Job Profiles"
			description="View our full list of university city guides"
			categoryUrl="career"
		/>
	</div>
}

<uc-recommended-unis-carousel />

<!-- snigel google ads -->
<div class="container">
	<div class="divider">
		<div class="hidden sm:block">
			<div id="adngin-incontent_2_dskt-0" class="mx-auto incontent_1_dskt-0"></div>
		</div>

		<div class="sm:hidden">
			<div id="adngin-incontent_2_mob-0" class="mx-auto incontent_1_mob-0"></div>
		</div>
	</div>
</div>

<uc-sticky-lead-bar-renderer leadType="BOOK_EVENT" colorScheme="ROSE" />
